export const getHyphenatedPhoneNumber = (phone) => {
    const phoneNumber = phone.replace(/\D/g, '');
    const phoneLength = phoneNumber.length;
    if (phoneLength > 3 && phoneLength <= 6) {
        return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3)}`;
    }
    if (phoneLength > 6) {
        return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
    }
    return phoneNumber;
};
